import { COLORS } from "shared/consts";
import styled from "styled-components";
import {toRem} from "shared/helpers";

const BaseWrap = styled.div`
    position: absolute;
    top: 24px;
    left: calc(100% + 4px);
    width: min(220px, 50vw);
    overflow-y: auto;
    max-height: 80dvh;
    height: max-content;
    border-radius: 8px;
    box-shadow:
            0px 32px 32px 0px ${COLORS.NEUTRAL.CONTAINER_SOFT},
            0px 0px 32px 0px ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
    background: ${COLORS.BG.SURFACE1};
    z-index: 10;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const AnimatedWrap = styled(BaseWrap)`
    &.hud-slide-enter {
        opacity: 0;
        transform: translateX(-12px);
    }
    &.hud-slide-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 200ms ease, transform 200ms ease;
    }
    &.hud-slide-exit {
        opacity: 1;
        transform: translateX(0);
    }
    &.hud-slide-exit-active {
        opacity: 0;
        transform: translateX(-12px);
        transition: opacity 150ms ease, transform 150ms ease;
    }
`;

export const Title = styled.h3`
    color: ${COLORS.FG.MUTED};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    padding: 6px 12px;
    margin: 8px 0 4px;
    width: calc(100% - 16px);
`

export const AddApiaryButtonWrapper = styled.div`
    padding: 12px 8px;
    /* border-top: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15)); */
    border-top: 1px solid ${COLORS.BORDER.MUTED};
    width: 100%;
    margin-top: ${toRem(10)};
    > * {
        width: 100%;
    }
`
